<template>
  <div class="mainContainer">
    <el-row class="head">
      <el-col :span="18">
        <div class="header-36-black">ผู้ดูแล</div>
      </el-col>
      <el-col class="right" :span="6">
        <router-link :to="{ name: 'CaregiverCreate' }">
          <el-button type="primary" style="padding: 8px 20px;"><img src="@/assets/icon/plus.svg" width="18px" height="18px"></el-button>
        </router-link>
      </el-col>
    </el-row>
    <el-row class="rowFilter">
      <el-col :span="2">
        <div class="header-text">ผู้ดูแลประเภท</div>
      </el-col>
      <el-col :span="18">
        <el-checkbox-group v-model="query.types" @change="getCaregiverslist">
          <el-checkbox v-for="type1 in types" :key="type1" :label="type1" border="border" size="medium"></el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-row class="rowFilter" style="margin-top: 8px;">
      <el-col :span="2">
        <div class="header-text">ที่มีทักษะ</div>
      </el-col>
      <el-col :span="18">
        <el-checkbox-group v-model="selectedSkills" @change="getCaregiverslist">
          <el-checkbox v-for="skill in skills" :key="skill" :label="skill" border="border" size="medium"></el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-row class="rowFilter" style="margin-top: 8px;">
      <el-col :span="2"></el-col>
      <el-col :span="1.5">
        <div class="box"><img src="https://storage.healthathome.in.th/cc561010-da21-439c-8428-3c786f6ee441.svg" width="18px" height="18px">
          <div>&nbsp; &nbsp; จำนวน &nbsp; &nbsp; {{ totalItems }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row class="line-split"></el-row>
    <el-row class="table">
      <caregiver-table v-if="list" :caregiversList="list" :totalItems="totalItems" @page="pageChange" :perPage="perPage" @search="search" :loading="loadingTable"></caregiver-table>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
  .mainContainer {
    padding: 155px 100px 20px 100px;
  }

  .el-row {
    padding-left: 40px;
  }

  .right {
    text-align: right;
  }

  .head {
    padding: 40px;
  }

  .el-button {
    width: 120px;
  }

  .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .el-checkbox {
    font-size: 14px;
    margin: 0 8px 8px 0;
    color: #D5D6DB;
  }

  .header-text {
    color: #5489FF;
    font-size: 14px;
    font-weight: 600;
  }

  .rowFilter {
    display: flex;
    align-items: baseline;
  }

  .table {
    margin-top: 60px;
    width: 100%;
  }

  .box {
    padding: 9px 15px;
    width: auto;
    background-color: #F9F9FA;
    border-radius: 3.6px;
    color: #D5D6DB;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .line-split {
    height: 3px;
      background: #E4E7ED;
      margin-top: 32px;
    }
</style>

<script>
import CaregiverTable from '@/components/caregiver/CaregiverTable'
import CaregiverTableRowModel from '../../model/CaregiverTableRowModel'
import { Value, Storage } from '../../model/ModelUtil'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  mounted () {
    this.getCaregiverslist()
  },
  mixins: [GenericAPIHandler],
  components: {
    CaregiverTable,
  },
  data () {
    return {
      loadingTable: false,
      types: Value.caregiver.all(),
      skills: [...Value.skill.generalThaiAll(), ...Value.skill.othersThaiAll()],
      selectedSkills: Storage.list.from('skills'),
      list: [],
      currentPage: 1,
      perPage: 250,
      totalItems: 0,
      query: {
        types: Storage.list.from('types'),
        skills: [],
        lastActive: false,
        query: this.filterText,
      },
      filterText: '',
    }
  },
  methods: {
    async pageChange (page) {
      this.query.page = page
      await this.getCaregiverslist()
    },
    async search (query) {
      this.filterText = query
      await this.getCaregiverslist()
    },
    async getCaregiverslist () {
      this.loadingTable = true
      this.query.skills = this.selectedSkills.map((skill) => Value.skill.from(skill))
      this.query.query = this.filterText
      this.query.page = this.query.page === undefined ? 1 : this.query.page
      this.query.limit = 250
      sessionStorage.setItem('types', this.query.types.toString())
      sessionStorage.setItem('skills', this.selectedSkills.toString())
      try {
        let raw = await this.$api.Caregiver.list(this.query)
        this.currentPage = raw.currentPage
        this.totalItems = raw.totalItems
        this.perPage = raw.perPage
        this.list = raw.list.map((json) => CaregiverTableRowModel.fromJSON(json))
        this.loadingTable = false
      } catch (error) {
        this.loadingTable = false
        this.showErrorDialog(error)
      }
    },
  },
}
</script>
